function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null, ".cls-japan-flag1{fill:#fff;stroke:#36546b;stroke-miterlimit:10;stroke-width:1px;}.cls-japan-flag2{fill:#fa4949;}");

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  className: "cls-japan-flag1",
  x: 1,
  y: 1,
  width: 65,
  height: 47.33,
  rx: 0.86,
  ry: 0.86
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  className: "cls-japan-flag2",
  cx: 33.5,
  cy: 24.67,
  r: 15
});

var SvgJapanese = function SvgJapanese(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 67 49.33",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgJapanese, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Japanese.edef7407.svg";
export { ForwardRef as ReactComponent };